// Elegir la credencial de un proveedor o un conector, o escribir una nueva ahí mismo: se guarda cifrada en la
// bóveda al guardar el formulario y queda con nombre para reusarla (una misma clave de OpenAI para dos cosas).
import { useQuery } from '@tanstack/react-query';
import { Input, Select } from '@glubi/ds';
import { api } from '../lib/api';

export type EstadoCredencial = { modo: 'ninguna' } | { modo: 'existente'; id: string } | { modo: 'nueva'; nombre: string; valor: string };

export const credencialInicial = (id: string | null | undefined): EstadoCredencial => (id ? { modo: 'existente', id } : { modo: 'nueva', nombre: '', valor: '' });

export async function resolverCredencial(e: EstadoCredencial): Promise<string | null> {
  if (e.modo === 'ninguna') return null;
  if (e.modo === 'existente') return e.id;
  if (!e.valor.trim()) return null;
  const r = await api<{ id: string }>('/api/secretos', { nombre: e.nombre.trim(), valor: e.valor.trim() });
  return r.id;
}

export function ElegirCredencial({ valor, onChange, ayuda, nombreSugerido, opcional }: {
  valor: EstadoCredencial; onChange: (v: EstadoCredencial) => void; ayuda?: string; nombreSugerido: string; opcional?: boolean;
}) {
  const secretos = useQuery({ queryKey: ['secretos'], queryFn: () => api<any[]>('/api/secretos') });
  const opciones = [
    ...(opcional ? [{ value: '_ninguna', label: 'Sin credencial' }] : []),
    { value: '_nueva', label: 'Escribir una nueva…' },
    ...(secretos.data ?? []).map((s) => ({ value: s.id as string, label: `${s.nombre} (${s.pista})` })),
  ];
  const actual = valor.modo === 'existente' ? valor.id : valor.modo === 'nueva' ? '_nueva' : '_ninguna';
  return (
    <div className="stack" style={{ gap: 10 }}>
      <Select label="Credencial" value={actual} options={opciones} onChange={(e) => {
        const v = e.target.value;
        onChange(v === '_ninguna' ? { modo: 'ninguna' } : v === '_nueva' ? { modo: 'nueva', nombre: nombreSugerido, valor: '' } : { modo: 'existente', id: v });
      }} />
      {valor.modo === 'nueva' && (
        <div className="grid-2" style={{ gap: 10 }}>
          <Input label="Nombre de la credencial" value={valor.nombre} onChange={(e) => onChange({ ...valor, nombre: e.target.value })} />
          <Input label="Valor" type="password" value={valor.valor} onChange={(e) => onChange({ ...valor, valor: e.target.value })} helper={ayuda ?? 'Se guarda cifrada y no se vuelve a mostrar'} />
        </div>
      )}
    </div>
  );
}
